// @ts-check
if (!customElements.get("ff-flex-grid")) {
  class FfFlexGrid extends HTMLElement {
    constructor() {
      super();

      this.ffInit();
    }

    ffInit() {
      const content = this.querySelector(this.dataset.ffContentSelector || "");

      if (content?.children && content.children.length > 1) {
        /**
         * @type {HTMLElement[]}
         */
        this.ffCells = Array.from(content.children);

        this.ffResizeCells();

        window.removeEventListener("resize", this.ffShopifySectionLoadHandler);
        window.addEventListener("resize", this.ffShopifySectionLoadHandler);
      }
    }

    ffResizeCells() {
      const { ffMobileBreakpoint } = this.dataset;

      if (
        !ffMobileBreakpoint ||
        window.matchMedia(`(min-width:${ffMobileBreakpoint}px)`).matches
      ) {
        var resizeCells = this.dataset.hasOwnProperty("ffResizeCells");
      } else {
        var resizeCells = this.dataset.hasOwnProperty("ffResizeCellsMobile");
      }

      if (resizeCells) {
        let highestHeight = 0;

        this.ffCells?.forEach(({ clientHeight }) => {
          if (clientHeight > highestHeight) {
            highestHeight = clientHeight;
          }
        });

        this.ffCells?.forEach((cell) => {
          cell.style.minHeight = `${highestHeight}px`;
        });
      }
    }

    ffShopifySectionLoadHandler = () => {
      if (this.hasAttribute("data-ff-resize-cells")) {
        this.ffCells?.forEach((cell) => {
          cell.style.minHeight = "";
        });

        setTimeout(() => {
          this.ffResizeCells();
        }, 200);
      }
    };
  }

  customElements.define("ff-flex-grid", FfFlexGrid);
}

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    requestAnimationFrame(() => {
      document.querySelectorAll("ff-flex-grid").forEach((cell) => {
        cell.ffShopifySectionLoadHandler();
      });
    });
  });
}
